import { cx } from '@linaria/core';
import { Button } from 'components/ui_library/Button';
import { IconCloseSquare } from 'components/Icons';
import { flex } from 'styles/utils';

type ModalHeaderProps = {
  title: string;
  onClose: () => void;
};

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => {
  return (
    <div className={cx(flex.init, flex.justifyContent.between, flex.alignItems.center)}>
      <h1 className="title">{title}</h1>
      <Button variant="unstyled" onClick={onClose}>
        <IconCloseSquare size={20} />
      </Button>
    </div>
  );
};
